import { useMutation, useQuery } from '@tanstack/react-query'
import {
  checkSerialNumber,
  createRequestWithLinkToService,
  linkRequestToServiceOrder,
  sendExistedRequestToServiceCenter,
} from '../../../../../services/NewApiService'
import { LinkToServiceBody } from '../types/NewDrawers.types'

export const useServiceApi = (serialNum: string | null) => {
  const {
    data: serialResponse,
    isPending,
    error: serialResponseError,
  } = useQuery({
    queryKey: ['check-serial-number', serialNum],
    queryFn: () => checkSerialNumber(serialNum ?? ''),
    enabled: !!serialNum,
    retry: 0,
    staleTime: 0,
  })

  const { mutateAsync: createWithLinkToService, isPending: isCreating } =
    useMutation({
      mutationKey: ['create-with-link-to-service-request'],
      mutationFn: ({ body }: { body: any }) =>
        createRequestWithLinkToService(body),
    })

  const { mutateAsync, isPending: isSending } = useMutation({
    mutationKey: ['send-existed-request-to-service-center'],
    mutationFn: (variables: { orderId: number; data: any }) =>
      sendExistedRequestToServiceCenter(variables.orderId, variables.data),
  })

  const { mutateAsync: linkToService, isPending: isLinking } = useMutation({
    mutationKey: ['link-to-service-request'],
    mutationFn: ({
      orderId,
      requestId,
      body,
    }: {
      orderId: number
      requestId: number
      body: LinkToServiceBody
    }) => linkRequestToServiceOrder(orderId, requestId, body),
  })
  return {
    mutateAsync,
    createWithLinkToService,
    serialResponse,
    linkToService,
    isPending,
    isSending,
    isCreating,
    isLinking,
    serialResponseError,
  }
}
